var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHotReleaseLg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.823,
    height: 20.659,
    viewBox: "0 0 12.823 20.659",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hotfix_fire_ic",
    transform: "translate(-97.103 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11363",
    "data-name": "Path 11363",
    d: "M97.1,14.247a6.411,6.411,0,0,0,6.411,6.411h0a6.411,6.411,0,0,0,6.411-6.411c0-3.562-1.781-6.411-.586-8.9,0,0-1.907.356-2.976,3.206A9.043,9.043,0,0,1,104.29,0a5.769,5.769,0,0,0-3.246,6.055c.325,3.971-.379,4.631-.379,4.631a5.469,5.469,0,0,0-2.506-4.631C98.884,9.972,97.1,11.041,97.1,14.247Z",
    transform: "translate(0)",
    fill: "#ef5656"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11364",
    "data-name": "Path 11364",
    d: "M158.625,176.722a4.765,4.765,0,0,1-4.726,4.892,4.088,4.088,0,0,1-4.177-4.451,10.8,10.8,0,0,1,2.315-4.742l.92.557A18.63,18.63,0,0,1,154,167.724C154.7,170.883,158.625,171.7,158.625,176.722Z",
    transform: "translate(-50.482 -160.957)",
    fill: "#ffdc64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11365",
    "data-name": "Path 11365",
    d: "M186.448,284.62c-.356,2.137-1.069,2.915-1.069,4.274a2.95,2.95,0,0,0,2.85,2.85h0a2.858,2.858,0,0,0,2.85-2.88,8.666,8.666,0,0,0-2.493-6.381,3.727,3.727,0,0,1-.712,3.206A3.62,3.62,0,0,0,186.448,284.62Z",
    transform: "translate(-84.714 -271.086)",
    fill: "#ffb446"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotReleaseLg);
export default __webpack_public_path__ + "static/media/hotReleaseLg.0a0d21c9.svg";
export { ForwardRef as ReactComponent };